/**
 * Thin GA wrapper for the candidate pages.
 *
 * These events were built to compare the candidate pages against the live ones.
 * Now that the candidates ARE `/` and `/pricing`, they measure the live funnel, so
 * the CTAs that decide that call are instrumented. Mirrors the activation rules
 * in `__root.tsx`: gtag is only ever loaded when `VITE_GOOGLE_ANALYTICS_ID` is
 * set and never in DEV, so this no-ops in local development rather than throwing
 * on an absent `window.gtag`.
 */

export type SolutionEvent =
  | "hero_primary_cta"
  | "hero_secondary_cta"
  | "problem_card"
  | "pricing_tier_cta"
  | "qualifier_start"
  | "qualifier_complete"
  | "qualifier_capture_submit"
  | "final_cta";

/**
 * @param event  what happened
 * @param detail which instance - the problem card's title, the tier's id, the
 *               qualifier outcome. Kept to non-identifying values only: never
 *               pass the prospect's free-text problem or their email here.
 */
export function trackEvent(event: SolutionEvent, detail?: string): void {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  window.gtag("event", event, {
    event_category: "solution_led_messaging",
    ...(detail ? { event_label: detail } : {}),
  });
}
